module.exports = __webpack_public_path__ + "static/media/3.02103a03.jpg";